import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const POIsPermissionsApi = createApi({
	reducerPath: "POIsPermissions",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1`,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		addPOIsPermission: builder.mutation({
			query: (val) => ({
				url: `poiPermissions`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		deletePOIsPermission: builder.mutation({
			query: (val) => ({
				url: `poiPermissions`,
				method: "DELETE",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),

		getPOIsUnderUser: builder.query({
			query: ({ userId }) => `poiPermissions/user/${userId}`,
		}),
	}),
});

export const {
	useAddPOIsPermissionMutation,
	useDeletePOIsPermissionMutation,
	useGetPOIsUnderUserQuery,
} = POIsPermissionsApi;
